/*=========================================================================================
  File Name: modulePurchaseMutations.js
  Description: Purchase Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
  SET_PurchaseS(state, payload) {
    state.Purchases = payload;
  },
};
